<template>
  <el-dialog
    top="50px"
    width="400px"
    :title="isCreate ? 'Thêm nghiệp vụ mới' : 'Sửa nghiệp vụ'"
    :visible="visible"
    :show-close="!callingAPI"
    @close="$emit('close')"
  >
    <el-form
      ref="form"
      :model="form"
      :rules="rules"
      :show-message="true"
      size="small"
    >
      <el-row
        label-position="top"
        type="flex"
        align="start"
        class="flex-wrap"
        :gutter="12"
      >
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="key"
label="Mã nghiệp vụ">
            <el-input
              v-model="form.key"
              :disabled="!isCreate"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="name"
label="Tên nghiệp vụ">
            <el-input
v-model="form.name"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
        <el-col
        :lg="24"
        :span="24">
          <el-form-item
        prop="order"
        label="STT nghiệp vụ">
            <el-input-number
              v-model="form.order"
              class="w-100"
              placeholder="Nhập thông tin"
            />
          </el-form-item>
        </el-col>
        <el-col
:span="24">
          <el-form-item
prop="fields"
label="Trường dữ liệu">
            <el-select
              v-model="form.fields"
              placeholder="Chọn trường dữ liệu"
              class="w-100"
              multiple
              filterable
            >
              <el-option
                v-for="f in fields"
                :key="f.key"
                :label="f.name"
                :value="f.key"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
:lg="24"
:span="24">
          <el-form-item
prop="description"
label="Mô tả nghiệp vụ">
            <el-input
v-model="form.description"
type="textarea"
placeholder="Nhập thông tin" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span
slot="footer"
class="dialog-footer">
      <el-button
:disabled="callingAPI"
size="medium"
@click="$emit('close')">
        Đóng
      </el-button>
      <el-button
        type="primary"
        :loading="callingAPI"
        size="medium"
        @click="handleConfirm"
      >
        Lưu
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import PATTERNS from "@/config/patterns.js";
import { notification } from "@/utils/common";

export default {
  name: "ActionFormPopup",
  props: {
    item: Object,
    visible: Boolean,
    fields: Array,
    actions: Array,
  },
  data() {
    return {
      form: {
        key: this.item ? this.item.key : "",
        name: this.item ? this.item.name : "",
        order: this.item ? this.item.order : 0,
        description: this.item ? this.item.description : "",
        fields: this.item ? this.item.fields : [],
      },
      callingAPI: false,
    };
  },
  computed: {
    allActionKeys() {
      return (this.actions || [])
        .filter((c) => c.key !== this.item?.key)
        .map((c) => c.key);
    },
    rules() {
      const validateKey = (rule, value, callback) => {
        if (value && this.allActionKeys.includes(value.trim())) {
          callback(new Error("Mã đã tồn tại"));
        } else {
          callback();
        }
      };
      const validateFields = (rule, value, callback) => {
        if (!value || value.length <= 0) {
          callback(new Error("Chọn ít nhất 1 trường dữ liệu"));
        } else {
          callback();
        }
      };
      return {
        key: [
          {
            required: true,
            message: "Mã không được để trống",
            trigger: ["blur", "change"],
          },
          {
            pattern: PATTERNS.KEY,
            message: "Mã không hợp lệ",
            trigger: ["blur", "change"],
          },
          {
            validator: validateKey,
            trigger: ["blur", "change"],
          },
        ],
        name: [
          {
            required: true,
            message: "Tên không được để trống",
            trigger: ["blur", "change"],
          },
        ],
        fields: [
          {
            validator: validateFields,
            trigger: ["blur", "change"],
          },
        ]
      };
    },
    isCreate() {
      return !this.item || !this.item.key;
    },
  },
  methods: {
    handleConfirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let actions = [];
          if (this.isCreate) {
            actions = [this.form, ...this.actions];
          } else {
            actions = this.actions.map((g) => {
              if (g.key === this.item.key) {
                return this.form;
              }
              return g;
            });
          }
          this.$emit("save", {
            payload: { actions },
            success: () => {
              notification(
                this,
                "success",
                this.isCreate ? "create" : "update",
                `nghiệp vụ`
              );
              this.$emit("close");
            },
            error: () => {
              notification(
                this,
                "error",
                this.isCreate ? "create" : "update",
                `nghiệp vụ`
              );
            },
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
